import { gql } from "apollo-boost";

// Org-wide telematics vehicle list for the Tracking Report's vehicle picker — no business
// customer / booking-schedule scoping, just "belongs to this organisation" + "has telemetry"
// (inventory-api's getTelematicVehiclesForOrganisation resolver derives tenantId/organisationId
// from the request context only, never from GraphQL args).
// Booking-schedule lookup for the actual report window now happens server-side in
// notification-api's /report/request/vehicle, so this query doesn't need bookingSchedules —
// fetching that here for every org vehicle up front would scale badly for a vehicle with a
// long booking history.
export const GET_TELEMATIC_VEHICLES_FOR_ORGANISATION = gql`
  query getTelematicVehiclesForOrganisation {
    getTelematicVehiclesForOrganisation {
      id
      licencePlate
      make
      model
      isGhostVehicle
      telemetryDeviceId
      branchId
    }
  }
`;
